/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { ProvisionalPageService } from '@pages/ProvisionalPage/services';

const getSrv = () => {
  return vappContainer.get<ProvisionalPageService>(ProvisionalPageService.name);
};

export const getPolicyList = async (context: any, event: any) => {
  const currentState = 'GET_POLICY_LIST';
  const method = 'getPolicyList';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      const srv = getSrv();
      const _getArgs = () => {
        let _args: any = {};
        if (event?.type === 'START') {
          _args = context['GET_POLICY_LIST'];
        }
        if (event?.type === 'TRIGGER_REFRESH') {
          _args = {
            offset: event?.offset,
            size: event?.size,
            where: event?.where ?? [],
          };
        }
        console.log('getPolicyList args =>', _args);
        return _args;
      };
      const shelves = await srv.agent.getProvisionalListSync(_getArgs());
      if (shelves) {
        return resolve({
          key: 'RENDER_POLICY_LIST',
          value: {
            ...(shelves || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'RENDER_POLICY_LIST_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'RENDER_POLICY_LIST_ERROR',
        value: err?.message,
      });
    }
  });
};
